import React, { useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { partnerPortalAPI } from '../../lib/api';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const EMPTY = { nome: '', cpf: '', telefone: '', email: '', cidade: '', estado: '', cargo: '' };
const FIELDS = [
  ['nome', 'Nome completo *'], ['cpf', 'CPF *'], ['telefone', 'Celular *'], ['email', 'E-mail (opcional)'],
  ['cidade', 'Cidade'], ['estado', 'UF'], ['cargo', 'Cargo de interesse'],
];

const MASKS = {
  cpf: (v) => v.replace(/\D/g, '').slice(0, 11).replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d{1,2})$/, '$1-$2'),
  telefone: (v) => v.replace(/\D/g, '').slice(0, 11).replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d{1,4})$/, '$1-$2'),
};

export const PartnerCandidateDialog = ({ open, onClose, onSaved }) => {
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      const res = await partnerPortalAPI.createCandidate({ ...form, email: form.email || null, estado: form.estado.toUpperCase() || null });
      toast.success(res.data.message, { duration: 8000 });
      setForm(EMPTY);
      onSaved();
      onClose();
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Erro ao cadastrar');
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="partner-candidate-dialog">
        <DialogHeader>
          <DialogTitle>Cadastrar pessoa</DialogTitle>
          <DialogDescription>A pessoa poderá entrar no app G2eGente com o CPF e a senha inicial igual aos 6 primeiros dígitos do CPF.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          {FIELDS.map(([k, label]) => (
            <div key={k} className={['nome', 'email', 'cargo'].includes(k) ? 'col-span-2' : ''}>
              <Label htmlFor={`pc-${k}`}>{label}</Label>
              <Input id={`pc-${k}`} value={form[k]} maxLength={k === 'estado' ? 2 : undefined}
                onChange={(e) => setForm({ ...form, [k]: MASKS[k] ? MASKS[k](e.target.value) : e.target.value })} data-testid={`partner-candidate-${k}`} />
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={saving}>Cancelar</Button>
          <Button onClick={save} disabled={saving || !form.nome || !form.cpf || !form.telefone} className="bg-amber-500 hover:bg-amber-600" data-testid="partner-candidate-save">
            {saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Cadastrar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
